import { TextField, Tooltip } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

/**
 * One tri-state boolean for a bulk bar (the per-event bulk edit and the import
 * dialog's "Bulk defaults"). A native `<select>` (— / On / Off) so blank stays a
 * real "leave untouched" and the two set values map to the `'true'`/`'false'`
 * strings `parseBulkPatch` reads. Native (not a MUI menu) keeps the option list
 * flat + drivable.
 */
export function SniperTriState({
  label,
  tooltip,
  ariaLabel,
  value,
  onChange,
  sx,
}: {
  label: string;
  tooltip: string;
  ariaLabel: string;
  value: string;
  onChange: (value: string) => void;
  sx?: SxProps<Theme>;
}) {
  return (
    <Tooltip title={tooltip}>
      <TextField
        select
        size="small"
        label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        SelectProps={{ native: true, inputProps: { 'aria-label': ariaLabel } }}
        InputLabelProps={{ shrink: true }}
        sx={sx}
      >
        <option value="">—</option>
        <option value="true">On</option>
        <option value="false">Off</option>
      </TextField>
    </Tooltip>
  );
}
